import { ICargo } from '../entities/cargoes'
import { cargoes } from '../entities/cargoes-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { monsters } from '../monsters/monsters-sidecar'
import { assert } from '../lib/assert-sidecar'
import { l } from '../lib/imports'
import { findCargoF } from './advanceJob'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_moveTo } from './taskMoveTo'

export function createFetchCargoTask(
  i: number,
  j: number,
  cargoFilter: ((c: ICargo) => boolean) | null,
  cargoType: ICargoType | null,
  allowFromStack: boolean,
): ITask {
  assert.onlyOneIsNotNil(cargoFilter, cargoType)

  if (cargoType) {
    cargoFilter = (f) => f.data.type === cargoType
  }

  return jobs._createTask(i, j, 'fetch-cargo', {
    allowFromStack,
    cargoFilter,
  })
}

export function runTaskFetchCargo(job: IJob, task: ITask) {
  if (task.type !== 'fetch-cargo') {
    throw new Error('wrong task type')
  }
  let m = job.reservedBy
  if (!m) {
    throw new Error('job not reserved by anyone')
  }

  assert.notNil(task.cargoFilter)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  // Are we carrying the wrong thing?
  if (m.carryingCargo && !task.cargoFilter(m.carryingCargo)) {
    monsters.dropCargo(m)
    return
  }
  // Are we carrying the right thing?
  if (m.carryingCargo && task.cargoFilter(m.carryingCargo)) {
    return jobLogger.succeedTask(job, task)
  }

  // Find some cargo to pick up
  let cargoHere = cargoes.findAtSpot(
    m.i,
    m.j,
    task.cargoFilter,
    task.allowFromStack,
  )
  if (cargoHere) {
    monsters.pickupCargo(m, cargoHere)
    return
  }

  if (!task.targetCargo) {
    console.log('looking for cargo', task.cargoFilter, job.invalidCargoes)

    let cargo = findCargoF(
      task.i,
      task.j,
      task.cargoFilter,
      job.invalidCargoes,
      task.allowFromStack,
    )
    if (!cargo) {
      return jobLogger.failTask(job, task, 'lost cargo')
    }

    task.targetCargo = cargo
    return
  }
  // Sub path??

  task.subtasks.push(
    createTask_moveTo(
      task.targetCargo.i,
      task.targetCargo.j,
      task.targetCargo.isInShip,
      false,
      () => {
        jobLogger.assertTask(task)
        jobLogger.assertTrue(task.targetCargo != null, 'lost cargo')
        job.invalidCargoes.push(task.targetCargo)
        return false
      },
    ),
  )

  // if (task.targetCargo) {
  //   // Find path
  //   job.findPathId = pathFinder.findPath(
  //     m.i,
  //     m.j,
  //     task.targetCargo.i,
  //     task.targetCargo.j,
  //     m.isInsideShip,
  //     (path) => {
  //       job.findPathId = 0
  //       if (!task) {
  //         throw new Error('lost our task!')
  //       }
  //       if (!task.targetCargo) {
  //         throw new Error('lost our task cargo!')
  //       }

  //       if (!path || path.length === 0) {
  //         job.invalidCargoes.push(task.targetCargo)
  //       } else {
  //         if (m) {
  //           monsters.setPath(m, path)
  //         }
  //       }
  //       task.targetCargo = null
  //     },
  //   )
  // }
}
